import { Group, Enterprise, Doctor, Truck, Contributor } from "../components/Icons/index";
import { PUBLICURL } from "../main_config";
import { EMPRESAS_HOME } from "../routes/paths";

const menu_options = [
  {
    key: 1,
    value: "PERSONAS",
    icon: Group,
    url: "https://www.swissmedical.com.ar/prepagaclientes/"
  },
  {
    key: 2,
    value: "CORPORATIVO",
    icon: Enterprise,
    // Provisional: apunta a Home Empresas (antes PHP corporativo)
    url: `${PUBLICURL}${EMPRESAS_HOME}`
  },
  {
    key: 3,
    value: "PRESTADORES",
    icon: Doctor,
    url: "https://www.swissmedical.com.ar/prestadores/home/"
  },
  {
    key: 4,
    value: "PROVEEDORES",
    icon: Truck,
    url: "https://www.swissmedical.com.ar/proveedores/"
  },
  {
    key: 4,
    value: "COLABORADORES",
    icon: Contributor,
    url: "https://app.humand.co/"
  }
];

export default menu_options;
